





















import { defineComponent } from '@nuxtjs/composition-api';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import StaticPageHeader from '~/modules/storyblok/components/Static/StaticPagesHeader.vue';

export default defineComponent({
  name: 'StaticPagesWrapper',
  components: { StaticPageHeader, SkeletonLoader },
  props: {
    currentStory: {
      type: Object,
      default: null,
    },
  },
});
